import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { Dialog } from "primereact/dialog"

import Loading from "../../../../common/Loading";

import PIPunch from "../../../SellerPO/Components/PIPunch"

import { raiseToast } from "../../../../services/redux/reducers/toast/toast";
import { setSelectedSellerPO } from "../../../../services/redux/reducers/inward/inward";
import { fetchApprovals, fetchCompanyCreditPeriods } from "../../../../services/redux/reducers/commonThunk";

import { getSellerReqsByBuyerReqIds } from "../../../../services/api/sellerReq";
import { getBuyerQuoteItems } from "../../../../services/api/buyerQuoteItem";
import { getBuyerPOItemsByBuyerPOIds } from "../../../../services/api/buyerPOItem";
import { getSellerPIPunchBySellerPOId } from "../../../../services/api/sellerPIPunch";
import { getApprovalInstancesByDocNo } from "../../../../services/api/approvalInstances";


import { getPMCompanyConfig } from "../../../../setup/pmCompanyConfig";
import { getApprovalRequestStatusDetails, getApprovalStatus, getSellerPOApprovals } from "../../../../utils";

import { getNonRoutedSellerPOsInfoBySellerPOs } from "../../../../services/api/sellerPO";
import { searchMaterialMandatoryUseFromStock } from "../../../../services/api/materialMandatoryUseFromStock";


const PIPunchModal = (props) => {
    const { sellerPOId, sellerPOs, visiblePIPunch, setVisiblePIPunch, isLoading, setIsLoading, materialProductsData, selectedReq } = props

    const [sellerPO, setSellerPO] = useState({})
    const [sellerPOItems, setSellerPOItems] = useState([])
    const [sellerReqs, setSellerReqs] = useState([])
    const [sellerReqItems, setSellerReqItems] = useState([])
    const [sellerPIPunch, setSellerPIPunch] = useState([])
    const [sellerCompanyDetails, setSellerCompanyDetails] = useState({})
    const [approvalInstances, setApprovalInstances] = useState([])
    const [buyerQuoteItems, setBuyerQuoteItems] = useState([])
    const [buyerPOItems, setBuyerPOItems] = useState([])
    const [nonRoutedSellerPOsInfo, setNonRoutedSellerPOsInfo] = useState([])
    const [materialMandatoryUseFromStock, setMaterialMandatoryUseFromStock] = useState([])

    const approvals = useSelector((state) => state.common.approvals)
    const companyCreditPeriods = useSelector((state) => state.common.companyCreditPeriods)

    const userDetails = useSelector(state => state.userDetails)
    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    
    const dispatch = useDispatch()

    let sellerPOApprovals = useMemo(() => {
        return approvals.filter(eachApproval => pmCompanyConfig.sellerPOApprovalTypeIds.includes(eachApproval.approvalTypeId))
    }, [approvals])

    useEffect(() => {
        dispatch(fetchApprovals())
        dispatch(fetchCompanyCreditPeriods())
    }, [])

    useEffect(() => {
        if (sellerPO.sellerPOId && sellerPOItems.length, sellerPOApprovals?.length && (buyerQuoteItems?.length || sellerPO?.expenseCategoryId)){
            calculateApprovalsNew()
        }
    }, [approvalInstances, sellerPO, sellerCompanyDetails, sellerPOItems, sellerPOApprovals, buyerQuoteItems])  

    useEffect(() => {
        if (sellerPOId){
            getSellerPO()
        }
    }, [sellerPOId])

    const getSellerPO = async () => {
        setIsLoading(true)
        
        const relatedSellerPO = sellerPOs.find(eachSellerPO => eachSellerPO.sellerPOId === sellerPOId)
        const relatedSellerPOItems = props.sellerPOItems.filter(eachSellerPOItem => eachSellerPOItem.sellerPOId === sellerPOId)

        const sellerCompanyDetails = {
            companyId: relatedSellerPO.companyId,
            companyName: relatedSellerPO.sellerCompanyName,
            paymentTerms: relatedSellerPO.sellerPaymentTerms
        }

        const sellerPIPunchRes = await getSellerPIPunchBySellerPOId({sellerPOId: sellerPOId})
        if (sellerPIPunchRes.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Seller PI Punch', detail: sellerPIPunchRes.data.error, life: 3000 }))
        }

        const approvalInstanceRes = await getApprovalInstancesByDocNo({ docNo: relatedSellerPO.docNo })
        if (approvalInstanceRes.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Approval instances', detail: approvalInstanceRes.data.error, life: 3000 }))
        }

        const buyerPOItemsRes = await getBuyerPOItemsByBuyerPOIds([relatedSellerPO.buyerPOId])
        if (buyerPOItemsRes.failure){
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Buyer PO Items', detail: buyerPOItemsRes.data.error, life: 3000 }))
        }

        const buyerQuoteItemIds = buyerPOItemsRes.data.map(eachBuyerPOItem => eachBuyerPOItem.buyerQuoteItemId)

        const buyerQuoteItemRes = await getBuyerQuoteItems({buyerQuoteItemIds: buyerQuoteItemIds})
        if (buyerQuoteItemRes.failure){
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Buyer Quote Items', detail: buyerQuoteItemRes.data.error, life: 3000 }))
        }

        const nonRoutedSellerPORes = await getNonRoutedSellerPOsInfoBySellerPOs({sellerPOs: [{...relatedSellerPO}]})

        if (nonRoutedSellerPORes.failure){
            return dispatch(raiseToast({ severity: 'error', summary: "Non Routed Seller POs", detail: nonRoutedSellerPORes.data.error, life: 3000 }))
        }
        setNonRoutedSellerPOsInfo(nonRoutedSellerPORes.data)
        
        const sellerReqRes = await getSellerReqsByBuyerReqIds({buyerReqIds: [relatedSellerPO.buyerReqId], isItemsRequired: true})
        if (sellerReqRes.failure){
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Seller Req', detail: sellerReqRes.data.error }))
        }

        const materialIds = relatedSellerPOItems.map(eachSellerPOItem => eachSellerPOItem.materialId)
        const materialMandatoryUseFromStockRes = await searchMaterialMandatoryUseFromStock({materialIds, paginator: false})
        if(materialMandatoryUseFromStockRes.failure){
            return dispatch(raiseToast({severity:'error', summary:'Mandatory material use from stock',  detail: materialMandatoryUseFromStockRes.data.error, life: 3000}))
        }

        setMaterialMandatoryUseFromStock(materialMandatoryUseFromStockRes.data.data)

        setSellerPO(relatedSellerPO)
        setSellerPOItems(relatedSellerPOItems)
        setSellerReqs(sellerReqRes.data.sellerReqs)
        setSellerReqItems(sellerReqRes.data.sellerReqItems)
        setSellerCompanyDetails(sellerCompanyDetails)
        setSellerPIPunch(sellerPIPunchRes.data.sellerPIPunch)
        setApprovalInstances(approvalInstanceRes.data)
        setBuyerQuoteItems(buyerQuoteItemRes.data.data)
        setBuyerPOItems(buyerPOItemsRes.data)
        setNonRoutedSellerPOsInfo(nonRoutedSellerPORes.data)
        setIsLoading(false)
    }

    const calculateApprovalsNew = () => {
        setIsLoading(true)

        let updatedSellerPO = {...sellerPO}

        const relatedNonRoutedSellerPOsInfo = nonRoutedSellerPOsInfo.find(eachNonRoutedSellerPO => eachNonRoutedSellerPO.companyId === updatedSellerPO.companyId && eachNonRoutedSellerPO.docNo === updatedSellerPO.docNo)

        let updatedRequiredApprovals = getSellerPOApprovals({
            POApprovals: sellerPOApprovals, 
            sellerPO: updatedSellerPO, 
            sellerPOItems: sellerPOItems, 
            sellerCompanyDetails: sellerCompanyDetails, 
            buyerQuoteItems: buyerQuoteItems, 
            companyCreditPeriods: companyCreditPeriods,
            materialMasterData: materialProductsData,
            sellerPIPunch: sellerPIPunch,
            buyerReq: selectedReq,
            buyerPOItems: buyerPOItems,
            sellerReqs: sellerReqs,
            sellerReqItems: sellerReqItems,
            nonRoutedSellerPOsInfo: relatedNonRoutedSellerPOsInfo,
            materialMandatoryUseFromStock: materialMandatoryUseFromStock
        })

        const approvalIns = approvalInstances ? approvalInstances : []
        const approvalRequestStatusDetails = getApprovalRequestStatusDetails({
            updatedRequiredApprovals: updatedRequiredApprovals, 
            approvalInstances: approvalIns, 
            approvals: sellerPOApprovals, 
            pmBranchId: sellerPO?.pmBranchId, 
            sellerPO: updatedSellerPO
        })

        let pendingApprovalsExist = false
        if (approvalRequestStatusDetails.length){
            let approvalStatus = getApprovalStatus(approvalRequestStatusDetails)
            pendingApprovalsExist = approvalStatus.pendingApprovalsExist
        }

        if (updatedSellerPO.emailSent){
            pendingApprovalsExist = false
        }

        if (pendingApprovalsExist){
            setIsLoading(false)
            dispatch(setSelectedSellerPO(null))
            return dispatch(raiseToast({ severity: 'error', detail: 'Approvals are pending for this seller PO.' }))
        } else{
            setIsLoading(false)
            setVisiblePIPunch(true)
        }
    }

    const handleOnHideDialog = () => {
        setVisiblePIPunch(false)
        dispatch(setSelectedSellerPO(null))
    }
    
    return (
        <>
            <Loading visible={isLoading}/>
            <Dialog header="PI Punch" className="pi-punch-dialog" visible={visiblePIPunch} style={{ width: '90vw', height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => handleOnHideDialog()} >
                <PIPunch sellerPOId={sellerPOId}/>
            </Dialog>
        </>
    )
}

export default PIPunchModal;